import {
  DATE_TIME_PICKER,
  IMAGE,
  SELECT,
  SWITCH,
  TEXT,
  TEXT_EDITOR,
} from "../../components/Common/Const";

export const CompetitionFields = [
  {
    name: "eventTypeId",
    label: "Event Type",
    isRequired: true,
    parentclassName: "",
    type: SELECT,
    options: [{ label: "Select Event Type", value: "0" }],
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "competition",
    isRequired: true,
    label: "Competition",
    regex: /^.{0,100}$/,
    regexErrorMessage: "Max allowed Characters 100",
    parentclassName: "",
    type: TEXT,
  },
  {
    name: "refId",
    isRequired: true,
    label: "Reference Id",
    regex: /^.{0,100}$/,
    regexErrorMessage: "Max allowed Characters 100",
    parentclassName: "",
    type: TEXT,
  },
  {
    name: "image",
    label: "logo",
    parentclassName: "",
    type: IMAGE,
    isValidateImage: true,        
    validateWidth:279,
    validateHeight:376  
  },
  {
    name: "matchTypeId",
    label: "Match Type",
    parentclassName: "",
    type: SELECT,
    options: [{ label: "Select Match Type", value: "0" }],
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "type",
    label: "Type",
    options: [
      { label: "Select Type", value: "0" },
      { label: "International", value: 1 },
      { label: "Domestic", value: 2 },
    ],
    isRequired: true,
    type: SELECT,
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "startDate",
    label: "From",
    isRequired: true,
    // customStyle: {
    //   maxWidth: "600px",
    // },
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: DATE_TIME_PICKER,
  },
  {
    name: "endDate",
    label: "To",
    isRequired: true,
    // customStyle: {
    //   maxWidth: "600px",
    // },
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    type: DATE_TIME_PICKER,
  },
  {
    type: SELECT,
    name: "countryId",
    label: "Country",
    parentclassName: "",
    options: [{ label: "Select Country", value: "0" }],
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "commStatus",
    label: "Status",
    options: [
      { label: "Select Type", value: "0" },
      { label: "Upcoming", value: 1 },
      { label: "Started", value: 2 },
      { label: "Completed", value: 3 },
      { label: "Stop", value: 4 },
    ],
    // isRequired: true,
    type: SELECT,
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "isCallPyhtonService",
    label: "Python Service",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    dependsOnField: "isCallPyhtonService",
    dependsOnValue: true,
    name: "pythonId",
    label: "API",
    parentclassName: "",
    type: SELECT,
    options: [{ label: "Select API", value: "0" }],
    defaultValue: "0",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: TEXT,
    name: "drsCount",
    label: "Drs Count",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "tpId",
    label: "TPID",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  // { //added just for alignment
  //   name: "dummy",
  //   label: "Dummy",
  //   type: TEXT,
  //   dependsOnField: "dependOnDummyData",
  //   dependsOnValue: true,
  //   labelColspan: { xs: 12, md: 2, lg: 2 },
  //   fieldColspan: { xs: 12, md: 4, lg: 4 },
  // },
  {
    name: "isVirtual",
    label: "Virtual",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isMen",
    label: "Is Men",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isTrending",
    label: "Trending",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isEventSnap",
    label: "Is Event Snap",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isActive",
    label: "Active",
    defaultValue: true,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isCompetitionStatisticsCalculation",
    label: "Competition Stats",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    name: "isPointTable",
    label: "Is Point Table",
    defaultValue: false,
    parentclassName: "",
    type: SWITCH,
  },
  {
    type: TEXT,
    name: "winPoint",
    label: "Win Point",
    dependsOnField: "isPointTable",
    dependsOnValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
    labelOnNewLine: true
  },
  {
    type: TEXT,
    name: "tiePoint",
    label: "Tie Point",
    dependsOnField: "isPointTable",
    dependsOnValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: TEXT,
    name: "lossPoint",
    label: "Loss Point",
    dependsOnField: "isPointTable",
    dependsOnValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: TEXT,
    name: "cancelPoint",
    label: "Cancel Point",
    dependsOnField: "isPointTable",
    dependsOnValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "setOfRules",
    label: "Set Of Rules",
    parentclassName: "",
    type: TEXT_EDITOR,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 10, lg: 10 },
    labelOnNewLine: true
  },

];
